import { ReactNode, useCallback, useState } from 'react';

import { useTranslate } from '@i18n';
import { Spinner, Heading2, Inline } from '@ui';

import * as css from './ActivityReportLayout.css';
import { ActivityReportHeader } from './components/ActivityReportHeader';

type ActivityReportLayoutProps = {
    sidebar: ReactNode;
    content: ReactNode;
    isLoading: boolean;
    backLink: () => string;
};

export const ActivityReportLayout = ({ sidebar, content, isLoading, backLink }: ActivityReportLayoutProps) => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const t = useTranslate();
    const handleInsideClick = useCallback(() => {
        if (openDrawer) {
            setOpenDrawer(false);
        }
    }, [openDrawer]);
    return (
        <div className={css.root}>
            <ActivityReportHeader backLink={backLink} onToggleDrawer={() => setOpenDrawer(true)} />
            <Inline flex={1} className={css.layout}>
                <div className={css.sidebar({ open: openDrawer })} onClick={handleInsideClick}>
                    <div className={css.sidebarHeading}>
                        <div className={css.sidebarHeadingText}>
                            <Heading2>{t('activity_report.title')}</Heading2>
                        </div>
                    </div>
                    {isLoading ? <Spinner size="m" /> : sidebar}
                </div>

                <div className={css.content}>
                    {isLoading ? <Spinner size="l" isAbsolute /> : <div className={css.container}>{content}</div>}
                </div>
            </Inline>
            {openDrawer && <div className={css.backdrop} onClick={() => setOpenDrawer(false)} />}
        </div>
    );
};
